import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isInLastRow'
})
export class IsInLastRowPipe implements PipeTransform {
  public transform(userIndex: number, studentsCount: number, isStudentsSectionCollapsed: boolean): boolean {
    let studentsInRow: number;
    if (isStudentsSectionCollapsed) {
      studentsInRow = 4;
    } else {
      studentsInRow = 3;
    }
    /* if there is more than one row of students, check if user is in last row */
    const studentRowIndex: number = Math.floor(userIndex / studentsInRow);
    const lastRowIndex: number = Math.floor((studentsCount - 1) / studentsInRow);
    return studentRowIndex === lastRowIndex && lastRowIndex > 0;
  }
}
